export default __webpack_public_path__ + "static/media/link-gray.155dfd73.svg";